<template>
    <div class="filters__bit">
        <div class="title trigger-collapse trigger-brands" @click="loadModels" ref="dropdownBrands">
            <span class="filter-title"> Modelos</span>
            <img class="icon-dropdown float-right" src="/assets/images/helpers/icon-dropdown.svg" alt="">
        </div>
        <div class="collapse">
            <div class="wrap_big_list">
                <ul class="list__bit grid__bit p-0 bullet-none mt-0 mb-7">
                    <li v-for="(model, key) in getModelsFilters()" :key="'models-' + model.value" class="item">
                        <input v-model="filters" :value="model.value" class="form-input-checkbox hidden" type="checkbox"
                        :name="'models-' + model.value" :id="'models-' + model.value">
                        <label :for="'models-' + model.value" class="checkbox-mark">
                            {{ model.name }}
                        </label>
                    </li>
                </ul>
            </div>
        </div>
    </div>
</template>

<script>
import {mapActions, mapState} from 'vuex';
export default {
    props: ['brand_id'],
    data: () => ({
        filters: [],
        allModels: false
    }),
    computed : {
        ...mapState('catalog',['models']),
    },
    watch: {
        'filters': {
            handler(newValue){
                this.debouncedFiltersUpdate(newValue)
            }, deep: true
        },
        'brand_id': {
            handler(values) {
                this.getModelsFilters(values);
            }, deep: true
        }
    },
    methods: {
        debouncedFiltersUpdate: _.debounce(function(newValue) {
            this.$emit('change', 'models', newValue)
        }, 1000),
        ...mapActions('catalog',['getModels']),

        loadModels() {
            this.getModels();
            this.modelsLoads = true;
        },

        moreModels(event) {
            let vm = this;
            event.preventDefault();
            vm.allModels = true;
        },

        getModelsFilters(brands) {
            return _.map(this.models, function(item, key) {
                return {
                    name: item.title,
                    value: item.id
                };
            });
        }
    }
}
</script>
